<template>
	<div class="agreement-modal-overlay">
		<v-card class="agreement-modal-card" rounded="lg" elevation="8">
			<v-card-title class="d-flex align-center px-6 pt-5 pb-3">
				<v-icon icon="mdi-file-document-check-outline" color="primary" class="me-3" />
				<span class="text-h5">Terms and Conditions</span>
			</v-card-title>

			<v-divider />

			<v-card-text class="px-6 pt-5">
				<div class="agreement-content">
					<h3>Welcome to TurnCare Portal</h3>
					<p>
						Please read and accept the following terms and conditions to continue using the TurnCare Portal.
					</p>
					<p>
						<strong>Terms of Use:</strong>
					</p>
					<p>
						This is the latest version of the message for the consent screen {{ AGREEMENT_VERSION }}:
					</p>
					<p v-for="(paragraph, index) in AGREEMENT_PARAGRAPHS" :key="index">
						{{ paragraph }}
					</p>
					<p>
						<strong>Acceptance:</strong>
					</p>
					<p>
						By clicking "I Agree" below, you confirm that you have read, understood, and agree to be bound
						by these terms and conditions.
					</p>
				</div>

				<div v-if="authStore.user?.isAdmin">
					<div class="agreement-checkbox-container">
						<v-checkbox
							v-model="agreed"
							:disabled="loading"
							label="I agree to the terms and conditions"
							hide-details
						/>
					</div>

					<v-alert
						v-if="error"
						type="error"
						density="compact"
						class="mt-4"
					>
						{{ error }}
					</v-alert>
				</div>

				<div v-else class="admin-required-message">
					<v-icon icon="mdi-alert-circle-outline" size="large" class="mb-2" />
					<p class="text-h6 mb-2">Administrator Access Required</p>
					<p>
						Only administrators can sign the facility agreement.
						Please contact an administrator to complete this step.
					</p>
				</div>
			</v-card-text>

			<v-divider />

			<v-card-actions class="justify-end px-6 py-4">
				<v-btn
					color="error"
					variant="outlined"
					rounded="xl"
					class="text-none px-5"
					:disabled="loading"
					@click="authStore.logout()"
				>
					Exit
				</v-btn>
				<v-btn
					v-if="authStore.user?.isAdmin"
					color="primary"
					variant="flat"
					rounded="xl"
					class="text-none px-5"
					:disabled="!agreed || loading"
					:loading="loading"
					@click="signAgreement"
				>
					Sign Agreement
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { AGREEMENT_PARAGRAPHS, AGREEMENT_VERSION } from '@utils/agreement'
import { useAgreementModalLogic } from './AgreementModal.logic'

const authStore = useAuthStore()
const { agreed, loading, error, signAgreement } = useAgreementModalLogic()
</script>

<style scoped src="./AgreementModal.css"></style>

